/** @jsx isolateComponent */

import { css } from '@emotion/core';
import { Fragment, ReactNode } from 'react';

import { isolateComponent } from '@zapier/common-utils';
import { Margin } from '@zapier/design-system';

const svgStyles = css`
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const contentWrapperStyles = css`
  position: relative;
  z-index: 1;
`;

type Props = {
  children: ReactNode;
  padding?: string | number;
};

export const StaticConfetti = ({ children, padding = 0 }: Props) => {
  return (
    <Fragment>
      <svg
        css={svgStyles}
        fill="none"
        height="155"
        viewBox="0 0 1188 155"
        width="1188"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          fill="#FC1C74"
          height="15.8151"
          opacity="0.5"
          transform="matrix(0.968675 0.248331 -0.247359 0.968924 14.519 143.449)"
          width="15.7862"
        />
        <rect
          fill="#FFC43E"
          height="15.8114"
          opacity="0.5"
          transform="matrix(0.90803 -0.418905 0.417464 0.908694 844.324 18.7019)"
          width="15.7899"
        />
        <rect
          fill="#FC1C74"
          height="11.8629"
          opacity="0.5"
          width="11.8381"
          x="211.591"
          y="28.5104"
        />
        <rect
          fill="#FF4A00"
          height="11.8384"
          opacity="0.5"
          transform="matrix(0.114873 0.99338 -0.993325 0.115348 931.021 63.4558)"
          width="11.8625"
        />
        <rect
          fill="#46CAEF"
          height="11.8505"
          opacity="0.5"
          transform="matrix(0.70637 0.707843 -0.70637 0.707843 1180.34 75.4829)"
          width="11.8505"
        />
        <rect
          fill="#FFC43E"
          height="11.8505"
          opacity="0.5"
          transform="matrix(0.706368 0.707845 -0.706368 0.707845 8.37085 47.8027)"
          width="11.8505"
        />
        <rect
          fill="#FF4A00"
          height="15.8006"
          opacity="0.5"
          transform="matrix(0.706368 0.707845 -0.706368 0.707845 105.049 23.2566)"
          width="15.8006"
        />
        <rect
          fill="#FC1C74"
          height="15.8007"
          opacity="0.5"
          transform="matrix(-0.706368 0.707845 -0.706368 -0.707845 1094.83 56.1903)"
          width="15.8007"
        />
        <rect
          fill="#46CAEF"
          height="13.8382"
          opacity="0.5"
          transform="matrix(0.968675 0.248331 -0.247359 0.968924 113.83 143.978)"
          width="29.599"
        />
        <rect
          fill="#FFC43E"
          height="13.8228"
          opacity="0.5"
          transform="matrix(0.635016 0.772499 -0.771193 0.636601 1057.33 123.566)"
          width="29.6321"
        />
        <rect
          fill="#FF4A00"
          height="9.86945"
          opacity="0.5"
          transform="matrix(0.458396 -0.888748 0.887967 0.459908 977.541 9.43005)"
          width="17.7865"
        />
        <rect
          fill="#46CAEF"
          height="9.87897"
          opacity="0.5"
          transform="matrix(0.819991 0.572377 -0.570769 0.82111 302.816 55.9469)"
          width="17.7693"
        />
        <rect
          fill="#FFC43E"
          height="9.87182"
          opacity="0.5"
          transform="matrix(0.570769 -0.821111 0.81999 0.572378 134.401 99.2202)"
          width="17.7822"
        />
      </svg>

      <Margin margin={padding}>
        <div css={contentWrapperStyles}>{children}</div>
      </Margin>
    </Fragment>
  );
};
